import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section id="checkout" className="bg-bordo text-crema py-20 px-4 md:px-8" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <div className="text-center mb-16 space-y-6 text-lg md:text-xl" data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dorado mb-8" data-id="element-112">
            Ese es el gran diferencial.
          </h2>

          <div className="bg-bordo-dark p-8 rounded-2xl my-12 text-left max-w-2xl mx-auto shadow-xl" data-id="element-113">
            <p className="font-serif text-2xl mb-6 text-dorado" data-id="element-114">
              Imaginá esto…
            </p>
            <p className="mb-2" data-id="element-115">Llegás cansado.</p>
            <p className="mb-2" data-id="element-116">No querés cocinar algo complicado.</p>

            <ul className="space-y-2 mb-6" data-id="element-117">
              <li data-id="element-118">✓ Sabés qué milanesa hacer.</li>
              <li data-id="element-119">✓ Sabés qué guarnición combinar.</li>
              <li data-id="element-120">✓ Sabés si conviene horno, sartén o airfryer.</li>
              <li data-id="element-121">
                ✓ Sabés cómo hacerla más liviana, más crocante o más completa.
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-crema text-bordo rounded-3xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto text-center border-4 border-dorado relative" data-id="element-122">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-dorado text-bordo-dark font-bold px-6 py-2 rounded-full uppercase tracking-wider shadow-lg" data-id="element-123">
            Oferta Especial
          </div>

          <div className="space-y-2 mb-8 text-gray-700 font-medium mt-8" data-id="element-124">
            <p data-id="element-125">No necesitás saber de cocina avanzada.</p>
            <p data-id="element-126">No necesitás ingredientes raros.</p>
            <p data-id="element-127">No necesitás pasar horas cocinando.</p>
            <p className="text-bordo font-bold text-xl mt-4" data-id="element-128">
              Solo necesitás una guía clara. Un sistema simple.
            </p>
            <p className="text-bordo font-bold text-xl" data-id="element-129">
              Y ganas de que tus milanesas dejen de ser "lo de siempre".
            </p>
          </div>

          <div className="my-12" data-id="element-130">
            <h4 className="text-2xl font-serif font-bold mb-4" data-id="element-131">
              🥩 La Biblia de la Milanesa
            </h4>
            <p className="mb-6" data-id="element-132">
              El sistema definitivo para cocinar milanesas ricas, rápidas y sin
              estrés.
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-133">
              <span className="text-gray-500 line-through text-2xl mb-2" data-id="element-134">
                Precio normal: $49.990
              </span>
              <div className="flex items-center gap-4" data-id="element-135">
                <span className="text-5xl md:text-7xl font-bold text-bordo" data-id="element-136">
                  $19.990
                </span>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-bold animate-pulse" data-id="element-137">
                  60% OFF HOY
                </span>
              </div>
              <p className="text-sm text-gray-500 mt-2" data-id="element-138">+ LOS 4 BONOS GRATIS</p>
            </div>

            <a href="https://checkout.ebookpoint.shop/cart/59446015131729:1" className="block w-full" data-id="element-139">
              <CTAButton className="w-full text-xl py-6" data-id="element-140" />
            </a>
            <p className="text-sm text-gray-500 mt-4" data-id="element-141">
              Pago 100% seguro. Acceso inmediato.
            </p>

            <CountdownTimer data-id="element-142" />
          </div>
        </div>
      </div>
    </section>;
}